const state = {

};

const mutations = {


    /*obtengo el companyId del usuario*/
    companyId: function (state, company_Id) {
        state.companyId = company_Id;
    },

};

const actions = {};

const getters = {
    /*emailUser(){
        return firebase.auth().currentUser.email
    },*/
};

export default {
    state,
    mutations,
    actions,
    getters,
}